import MuiAlert from '@mui/material/Alert'
import { styled } from '@mui/material/styles'

export const Alert = styled(MuiAlert)({
  width: '100%',
  alignItems: 'center',
})
